import { useCallback } from 'react'

import { GlobalSearchResponse } from '../../../types/GlobalSearchResponse'

export const useKeyboardNavigation = (
  results: GlobalSearchResponse['result'],
  onItemSelect: () => void,
  setActiveItem: React.Dispatch<React.SetStateAction<{ sectionIndex: number; itemIndex: number } | null>>,
  disableHover: () => void
) =>
  useCallback(
    (event: KeyboardEvent) => {
      disableHover()

      if (!results || results.length === 0) return

      switch (event.key) {
        case 'ArrowDown':
        case 'Tab': {
          setActiveItem((prev) => {
            if (prev === null) return { sectionIndex: 0, itemIndex: 0 }
            const newItemIndex = prev.itemIndex + 1
            if (newItemIndex >= results[prev.sectionIndex]?.items?.length) {
              if (prev.sectionIndex === results.length - 1) return { sectionIndex: 0, itemIndex: 0 }
              else return { sectionIndex: prev.sectionIndex + 1, itemIndex: 0 }
            }
            return { sectionIndex: prev.sectionIndex, itemIndex: newItemIndex }
          })
          event.preventDefault()
          break
        }
        case 'ArrowUp': {
          setActiveItem((prev) => {
            if (prev === null) return { sectionIndex: results.length - 1, itemIndex: 0 }
            const newItemIndex = prev.itemIndex - 1
            if (newItemIndex <= 0) {
              if (prev.sectionIndex === 0)
                return { sectionIndex: results.length - 1, itemIndex: results[results.length - 1].items.length - 1 }
              else
                return {
                  sectionIndex: prev.sectionIndex - 1,
                  itemIndex: results[prev.sectionIndex - 1].items.length - 1
                }
            }
            return { sectionIndex: prev.sectionIndex, itemIndex: newItemIndex }
          })
          event.preventDefault()
          break
        }
        case 'Enter':
          onItemSelect()
          event.preventDefault()
          break
      }
    },
    [onItemSelect, results, disableHover, setActiveItem]
  )
